module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password-container"
  }, [_c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require('../assets/img/cuelistBLACK.png'),
      "alt": "Cuelist Logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "forgot-password-card"
  }, [(!_vm.sent) ? _c('div', {
    staticClass: "form-container"
  }, [_c('h2', [_vm._v("Reset Your Password")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("Enter your email address and we'll send you a link to reset your password.")]), _vm._v(" "), _c('form', {
    staticClass: "forgot-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.emailError
    }
  }, [_c('label', {
    attrs: {
      "for": "forgot-email-input"
    }
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "forgot-email-input",
      "type": "email",
      "disabled": _vm.loading
    },
    on: {
      "blur": _vm.validateEmail
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), (_vm.emailError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "button-group"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary submit-button",
    attrs: {
      "disabled": !_vm.isValid || _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [(_vm.loading) ? _c('md-spinner', {
    staticClass: "md-accent",
    attrs: {
      "md-size": 20
    }
  }) : _c('span', [_vm._v("Send Reset Link")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "back-button",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("\n                        Back to Login\n                    ")])], 1)], 1)]) : _c('div', {
    staticClass: "success-message"
  }, [_c('md-icon', {
    staticClass: "success-icon"
  }, [_vm._v("check_circle")]), _vm._v(" "), _c('h3', [_vm._v("Email Sent!")]), _vm._v(" "), _c('p', [_vm._v("We've sent a password reset link to your email address.")]), _vm._v(" "), _c('p', {
    staticClass: "redirect-message"
  }, [_vm._v("Redirecting to login...")])], 1)]), _vm._v(" "), _c('core-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-652b8c90","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/forgot.vue
// module id = 1253
// module chunks = 21